<template>
    <div>
        <app-finalizacao-detalhar
            :finalizacao="finalizacao"
            :finalizacoesServicos="finalizacoesServicos"
            :mostrarTimeLine="exibirTimeline"
        >
            <template slot="footer" slot-scope="data">
                <app-btn-voltar></app-btn-voltar>
                <certidoes
                    class="ml-2"
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                ></certidoes>
                <historico
                    v-if="$temAcesso('CRED-UABS-FIN-06')"
                    titulo="Histórico do Registro de Pagamento"
                    :servicos="finalizacoesServicos"
                    :id="finalizacao.finalizacaoId"
                    class="ml-2"
                ></historico>
                <app-finalizacao-enviar-para-aprovacao
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></app-finalizacao-enviar-para-aprovacao>
                <app-finalizacao-aprovar-reprovar
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></app-finalizacao-aprovar-reprovar>
                <finalizacao-aprovar-com-justificativa
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></finalizacao-aprovar-com-justificativa>
                <btn-retornar-finalizacao
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></btn-retornar-finalizacao>
                <finalizacao-iniciar-reprovar
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></finalizacao-iniciar-reprovar>
                <btn-prioritario
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-2"
                ></btn-prioritario>
                <btn-especial
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-2"
                ></btn-especial>
                <b-button
                    variant="primary"
                    class="ml-2 mr-1"
                    @click.stop="mostrarAnexos = true"
                    v-if="$temAcessoView('CRED-FIN-ANX-00') && !mostrarAnexos"
                    ><i class="fa fa-paperclip"></i> Documentos</b-button
                >
                <btn-exportar
                    :finalizacao="finalizacao"
                    :finalizacoesServicos="finalizacoesServicos"
                    class="ml-1"
                ></btn-exportar>
                <b-button
                    variant="primary"
                    class="ml-2 mr-1"
                    @click.stop="mostrarTimeline()"
                    >{{ textoBtnTimeline }} Timeline</b-button
                >
                <slot name="finalizacaoFooter" v-bind="data"></slot>
            </template>
        </app-finalizacao-detalhar>
        <finalizacao-anexos2
            v-if="$temAcessoView('CRED-FIN-ANX-00') && mostrarAnexos"
            :finalizacao="finalizacao"
            :finalizacoesServicos="finalizacoesServicos"
            @fechar="mostrarAnexos = false"
        ></finalizacao-anexos2>
        <app-entregas
            :entregas="finalizacao.entregas"
            :movimentosServicos="movimentosServicos"
        >
            <template slot="botoes">
                <slot name="entregasBotoes"></slot>
            </template>
            <template slot="entregaAcoes" slot-scope="data">
                <slot name="entregaAcoes" v-bind="data"></slot>
                <app-finalizacao-desassociar-entrega
                    :finalizacao="finalizacao"
                    :finalizacaoEntrega="data"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                    class="ml-1"
                ></app-finalizacao-desassociar-entrega>
            </template>
        </app-entregas>
        <app-desp-viagens
            :despViagens="finalizacao.despesasViagens"
            :movimentosServicos="movimentosServicos"
        >
            <template slot="botoes">
                <slot name="despViagensBotoes"></slot>
            </template>
            <template slot="despViagemAcoes" slot-scope="data">
                <slot name="despViagemAcoes" v-bind="data"></slot>
                <app-finalizacao-desassociar-desp-viagem
                    :finalizacao="finalizacao"
                    :finalizacaoDespViagem="data"
                    :finalizacoesServicos="finalizacoesServicos"
                    @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
                ></app-finalizacao-desassociar-desp-viagem>
            </template>
        </app-desp-viagens>
        <app-finalizacao-anexos
            :finalizacao="finalizacao"
            :finalizacoesServicos="finalizacoesServicos"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
        ></app-finalizacao-anexos>
    </div>
</template>

<script>
import FinalizacaoDetalhar from './FinalizacaoDetalhar'
import Entregas from './../entregas/Entregas2'
import FinalizacaoAnexos from './FinalizacaoAnexos'
import FinalizacaoAnexos2 from './FinalizacaoAnexos2'
import FinalizacaoDesassociarEntrega from './FinalizacaoDesassociarEntrega'
import FinalizacaoEnviarParaAprovacao from './FinalizacaoEnviarParaAprovacao'
import FinalizacaoAprovarReprovar from './FinalizacaoAprovarReprovar'
import DespViagens from './../despviagens/DespViagens'
import FinalizacaoDesassociarDespViagem from './FinalizacaoDesassociarDespViagem'
import BtnExportar from './BtnExportar'
import Historico from '../../../../shared/components/Historico'
// import Historico from './FinalizacaoHistorico'
import Certidoes from './FinalizacaoCertidoes'
import BtnPrioritario from './BtnPrioritario'
import BtnEspecial from './BtnEspecial'
import BtnRetornarFinalizacao from './BtnRetornarFinalizacao.vue'
import FinalizacaoIniciarReprovar from './FinalizacaoIniciarReprovar.vue'
import FinalizacaoAprovarComJustificativa from './FinalizacaoAprovarComJustificativa.vue'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            required: true
        },

        movimentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarAnexos: false,
            textoBtnTimeline: 'Exibir',
            exibirTimeline: false
        }
    },

    methods: {
        obterFinalizacaoAtualizada() {
            this.$emit('obterFinalizacaoAtualizada')
        },
        mostrarTimeline() {
            this.exibirTimeline = !this.exibirTimeline
            if (!this.exibirTimeline) {
                this.textoBtnTimeline = 'Exibir'
            } else {
                this.textoBtnTimeline = 'Ocultar'
            }
        }
    },

    components: {
        AppFinalizacaoDetalhar: FinalizacaoDetalhar,
        AppEntregas: Entregas,
        AppFinalizacaoAnexos: FinalizacaoAnexos,
        AppFinalizacaoDesassociarEntrega: FinalizacaoDesassociarEntrega,
        AppFinalizacaoEnviarParaAprovacao: FinalizacaoEnviarParaAprovacao,
        AppFinalizacaoAprovarReprovar: FinalizacaoAprovarReprovar,
        AppDespViagens: DespViagens,
        AppFinalizacaoDesassociarDespViagem: FinalizacaoDesassociarDespViagem,
        BtnExportar: BtnExportar,
        Historico: Historico,
        Certidoes,
        FinalizacaoAnexos2,
        BtnPrioritario,
        BtnEspecial,
        BtnRetornarFinalizacao,
        FinalizacaoIniciarReprovar,
        FinalizacaoAprovarComJustificativa
    }
}
</script>
